import React from 'react'
import PropTypes from 'prop-types'
import useSmartviewMounter from '../hooks/use-smartview-mounter'
import MountSmartviewWithModel from './MountSmartviewWithModel'

function MountSmartview (props) {
  const mount = useSmartviewMounter(props.smartview, props.replace, props.keepTreeOnPush)

  React.useEffect(() => {
    mount()
  }, [])

  return null
}

MountSmartview.defaultProps = {
  smartview: null,
  replace: true,
  keepTreeOnPush: false
}

MountSmartviewWithModel.propTypes = {
  smartview: PropTypes.node,
  replace: PropTypes.bool,
  keepTreeOnPush: PropTypes.bool
}

export default MountSmartview
